// Widget Scripts
import swiperWidgetMainFeature from './js/widgets/swiperWidgetMainFeature.js';
import seoBloclSection from './js/widgets/seoBloclSection.js';
import tierThreeCards from './js/widgets/tierThreeCards.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget';

import footerImage from './js/widgets/footerImage.js';
import microModal from './js/widgets/microModal';

// Custom Theme Scripts
import './js/localjs.js';
import './js/SiteInfoBanner.js';
import MicroModal from 'micromodal';

// AOS > Animated on scroll
import AOS from 'aos';
import 'aos/dist/aos.css';


// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidgetMainFeature();
    seoBloclSection();
    tierThreeCards();
    multiScheduleFeature();
    $(window).load(function () {
      socialNetworkWidget.facebookfeed(true);
      socialNetworkWidget.twitterfeed(true);
      socialNetworkWidget.instafeed(true);
    })
    microModal()
    MicroModal.init();


    setTimeout(() => {
      AOS.init({
        anchorPlacement: 'bottom-bottom',
        animatedClassName: 'aos-animate',
        initClassName: 'aos-init',
      });
    }, 2000)
  });
}

$(document).ready(function () {
  footerImage();

})



